"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiloColumnFullWidthProps = exports.SiloColumnProps = void 0;
const constants_1 = require("utils/constants");
exports.SiloColumnProps = [
    {
        show: true,
        field: 'silo',
        title: 'Silo',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'target_queue_time_display',
        title: 'Target Queue Time',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'target_lead_time_display',
        title: 'Target Lead Time',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '140px',
        filter: 'boolean'
    },
];
exports.SiloColumnFullWidthProps = [
    ...exports.SiloColumnProps
];
exports.SiloColumnFullWidthProps[0] = {
    show: true,
    field: 'silo',
    title: 'Silo',
    width: 'auto',
    filter: 'text'
};
